"use client";
import {
  DisclosureContextProvider
} from "../__chunks/OAYFXAQ2.js";
import "../__chunks/3ORBWXWF.js";
import {
  useDisclosureStore
} from "../__chunks/SMM5JVLC.js";
import "../__chunks/4OZYHFMH.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/disclosure/disclosure-provider.tsx
import { jsx } from "react/jsx-runtime";
function DisclosureProvider(props = {}) {
  const store = useDisclosureStore(props);
  return /* @__PURE__ */ jsx(DisclosureContextProvider, { value: store, children: props.children });
}
export {
  DisclosureProvider
};
